export default __webpack_public_path__ + "static/media/noimage.e49fd033.png";